import React from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import { Color, CommonProperties, CommonStyles } from '../../styles';
import ExpenseReportCardInfo from './ExpenseReportCardInfo';
import ExpenseOption from './ExpenseOption';
import { Modals } from '../../constants/ScreenNames';
import { i18nNS } from '../../i18n';
import { useTranslation } from 'react-i18next';

export const RowBack = ({ onMove, onDelete, onReOpen, style }) => {
  const { t } = useTranslation(i18nNS.tripExpense);
  return (
    <View style={style ? style : styles.rowBack}>
      {typeof onMove === 'function' && (
        <ExpenseOption
          name={t('common:Move')}
          iconName="arrowRight"
          style={{ backgroundColor: Color.active }}
          onPress={onMove}
        />
      )}
      {typeof onDelete === 'function' && (
        <ExpenseOption
          name={t('common:Delete')}
          iconName="cancel"
          style={style ? styles.cardStyle : { backgroundColor: Color.required }}
          onPress={onDelete}
        />
      )}
      {typeof onReOpen === 'function' && (
        <ExpenseOption
          name={t('common:ReOpen')}
          iconName="info"
          style={{ backgroundColor: Color.active }}
          onPress={onReOpen}
        />
      )}
    </View>
  );
};

const ExpenseReportCard = ({
  props,
  item,
  onMoveItem,
  onAddExpenseItem,
  onsubmitExpense,
  onEditName,
  onViewPDF,
}) => {
  const submitted = item.Status === 'Submitted';
  return (
    <View style={styles.card}>
      <View style={CommonStyles.p3}>
        <TouchableOpacity
          onPress={() =>
            props.navigation.navigate(Modals.ExpenseReportCardModal, {
              item,
              onMoveItem,
              onAddExpenseItem,
              onsubmitExpense,
              onEditName,
              onViewPDF,
            })
          }
        >
          <ExpenseReportCardInfo item={item} onEditName={!submitted ? onEditName : null} />
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    backgroundColor: Color.accent,
    ...CommonProperties.shadow,
    ...CommonProperties.mx3,
    ...CommonProperties.my2,
    ...CommonProperties.borderRadius1,
  },
  rowBack: {
    backgroundColor: '#DDD',
    flex: 1,
    paddingVertical: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  cardStyle: {
    backgroundColor: Color.required,
    borderRadius: 5,
  },
});

export default ExpenseReportCard;
